import React from "react";

interface ArrowIconProps {
  className?: string;
}

export const ArrowIcon = ({ className }: ArrowIconProps): JSX.Element => {
  return (
    <svg className="shrink-0 fill-current text-slate-400" width="11" height="7" viewBox="0 0 11 7">
      <path d="M5.4 6.8L0 1.4 1.4 0l4 4 4-4 1.4 1.4z" />
    </svg>
  );
};
